import block from './block.json';

export const cardProductionThemeAttributes = {
	border: {
		color: '@tokens.variants.default.cardTitleColor',
		width: {
			top: [1, 1],
			right: [0, 0],
			bottom: [1, 1],
			left: [0, 0],
		},
	},
	padding: {
		top: [25, 20],
		right: [0, 0],
		bottom: [25, 20],
		left: [0, 0],
	},
	artist: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.fresco-s-italic',
		textAlignment: 'left',
	},
	text: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardProductionThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardProductionThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
